<template>
  <div class="bg-background-neutral-secondary space-y-6 rounded-xl p-4">
    <FreeInput
      v-model="contacts.email"
      v-maska:[inputsMasks.email]
      :label="$t('contacts.emailLabel')"
      placeholder="Muratov@example.com"
      type="email"
      :has-error="hasError('email')"
      @input="contactsStore.updateState({ email: $event.target.value })"
    >
      <template v-if="hasError('email')" #errorMessage>
        <p>{{ getErrorMessage('email') }}</p>
      </template>
    </FreeInput>
    <FreeInput
      v-maska:[inputsMasks.phoneNumber]
      :label="$t('contacts.phoneNumberLabel')"
      placeholder="+7 ___ ___ __ __"
      type="tel"
      :model-value="contacts.phone"
      :has-error="hasError('phone')"
      @input="contactsStore.updateState({ phone: $event.target.value })"
    >
      <template v-if="hasError('phone')" #errorMessage>
        <p>{{ getErrorMessage('phone') }}</p>
      </template>
    </FreeInput>
  </div>
</template>

<script setup lang="ts">
  import { computed, onBeforeMount } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useVuelidate } from '@vuelidate/core';
  import { FreeInput, aviaMasksOptions } from 'freedom-shared';
  import { contactValidation } from 'shared';

  import { accountModel } from '@/entities/account';

  import { useContactsStore } from './model';

  /**
   * Options must be assigned inside the script where it's used.
   * @see https://github.com/beholdr/maska/issues/149#issuecomment-1529619595
   * */
  const inputsMasks = aviaMasksOptions;

  const contactsStore = useContactsStore();
  const { state: contacts } = storeToRefs(contactsStore);

  const rules = contactValidation.lib.createRules('contacts.validations');
  const vuelidate = useVuelidate(
    rules,
    computed(() => ({ contacts })),
  );

  const hasError = (key: string) => vuelidate.value.contacts[key].$error;
  const getErrorMessage = (key: string) =>
    vuelidate.value.contacts[key].$errors[0].$message;

  onBeforeMount(() => {
    if (contactsStore.isContactsEmpty()) {
      const { data } = accountModel.useAccount();
      if (data.value) {
        contactsStore.updateState(data.value.contacts);
      }
    }
  });
</script>
